import { gql } from 'graphql-request'

export const CREATE_ROCKET_GAME_LIVE = gql`
  mutation CREATE_ROCKET_GAME_LIVE(
    $rocketGameId: Int!
    $userLiveId: Int!
    $quantityContribute: Int!
    $dateContribute: String!
    $typeRocketGameProgress: TypeRocketGameProgress!
  ) {
    createRocketGameLive(
      rocketGameId: $rocketGameId
      userLiveId: $userLiveId
      quantityContribute: $quantityContribute
      dateContribute: $dateContribute
      typeRocketGameProgress: $typeRocketGameProgress
    ) {
      error
      status
      data {
        id
        rocketGameId
        rocketGame {
          id
          name
        }
        userLiveId
        userLive {
          id
          username
        }
        quantityContribute
        dateContribute
        typeRocketGameProgress
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_ROCKET_GAME_LIVE = gql`
  mutation UPDATE_ROCKET_GAME_LIVE(
    $rocketGameLiveId: Int!
    $rocketGameId: Int
    $userLiveId: Int
    $quantityContribute: Int
    $dateContribute: String
    $typeRocketGameProgress: TypeRocketGameProgress
  ) {
    updateRocketGameLive(
      rocketGameLiveId: $rocketGameLiveId
      rocketGameId: $rocketGameId
      userLiveId: $userLiveId
      quantityContribute: $quantityContribute
      dateContribute: $dateContribute
      typeRocketGameProgress: $typeRocketGameProgress
    ) {
      error
      status
      data {
        id
        rocketGameId
        rocketGame {
          id
          name
        }
        userLiveId
        userLive {
          id
          username
        }
        quantityContribute
        dateContribute
        typeRocketGameProgress
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_ROCKET_GAME_LIVE = gql`
  query GET_ROCKET_GAME_LIVE($rocketGameLiveId: Int!) {
    getRocketGameLive(rocketGameLiveId: $rocketGameLiveId) {
      error
      status
      data {
        id
        rocketGameId
        rocketGame {
          id
          name
        }
        userLiveId
        userLive {
          id
          username
        }
        quantityContribute
        dateContribute
        typeRocketGameProgress
        createdAt
        updatedAt
      }
    }
  }
`
export const GET_ROCKETS_GAMES_LIVES = gql`
  query GET_ROCKETS_GAMES_LIVES(
    $take: Int
    $skip: Int
    $rocketGameId: Int
    $userLiveId: Int
    $quantityContribute: Int
    $typeFilterDateContribute: TypeFilter
    $dateContributeInitial: String
    $dateContributeFinal: String
    $typeRocketGameProgress: TypeRocketGameProgress
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getRocketsGamesLives(
      take: $take
      skip: $skip
      rocketGameId: $rocketGameId
      userLiveId: $userLiveId
      quantityContribute: $quantityContribute
      typeFilterDateContribute: $typeFilterDateContribute
      typeRocketGameProgress: $typeRocketGameProgress
      typeFilterCreatedAt: $typeFilterCreatedAt
      dateContributeInitial: $dateContributeInitial
      dateContributeFinal: $dateContributeFinal
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        id
        rocketGameId
        rocketGame {
          id
          name
          level
          quantityContribute
          imgRocketGame
        }
        userLiveId
        userLive {
          id
          username
        }
        quantityContribute
        dateContribute
        typeRocketGameProgress
        createdAt
        updatedAt
        dateInitialInExploded
        dateFinalInExploded
      }
    }
  }
`

export const GET_ROCKET_GAME_LIVE_FIRST = gql`
  query GET_ROCKET_GAME_LIVE_FIRST(
    $id: Int
    $rocketGameId: Int
    $userLiveId: Int
    $quantityContribute: Int
    $closed: Boolean
    $typeFilterDateContribute: TypeFilter
    $dateContributeInitial: String
    $dateContributeFinal: String
    $typeRocketGameProgress: TypeRocketGameProgress
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getRocketGameLiveFirst(
      id: $id
      rocketGameId: $rocketGameId
      userLiveId: $userLiveId
      quantityContribute: $quantityContribute
      closed: $closed
      typeFilterDateContribute: $typeFilterDateContribute
      dateContributeInitial: $dateContributeInitial
      dateContributeFinal: $dateContributeFinal
      typeRocketGameProgress: $typeRocketGameProgress
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        id
        rocketGameId
        rocketGame {
          id
          name
        }
        userLiveId
        userLive {
          id
          username
        }
        quantityContribute
        dateContribute
        typeRocketGameProgress
        createdAt
        updatedAt
      }
    }
  }
`
